import anime from 'animejs';

const template = {};

const wrapper = document.querySelector('[data-project-transition]');
const index = wrapper.querySelector('.project-list-item__index');
const title = wrapper.querySelector('.page-title');
const tags = wrapper.querySelector('.project-list-item__tags');

template.element = wrapper;

template.hide = () => {
  anime.set(wrapper, { visibility: 'hidden' });
};

template.show = () => {
  anime.set(wrapper, { visibility: 'visible' });
};

template.setPosition = (x, y) => {
  anime.set(wrapper, { translateX: x, translateY: y - title.offsetTop });
};

template.setTitle = (_html) => {
  title.innerHTML = _html;
};

template.setIndex = (_text) => {
  index.textContent = _text;
};

template.setTags = (_text) => {
  tags.textContent = _text;
};

export default template;
